import React from 'react';
import { AudioConfig } from '../../LiveContext/Hooks/useAudioConfig';

export default function useAudioStream(enabled: boolean, audioConfig: AudioConfig) {
  const [streamRef, setStreamRef] = React.useState<MediaStream | null>(null);
  const device = React.useMemo(() => audioConfig.deviceId, [audioConfig.deviceId]);
  const audioConfigRef = React.useRef(audioConfig);

  React.useEffect(() => {
    let isMounted = true;
    let localStream: MediaStream | null = null;

    if (enabled) {
      navigator.mediaDevices.getUserMedia({
        audio: {
          deviceId: device,
          sampleRate: 16000,
          noiseSuppression: audioConfigRef.current.noiseSuppression,
          echoCancellation: audioConfigRef.current.echoCancellation,
          autoGainControl: audioConfigRef.current.autoGainControl,
        },
      }).then((stream) => {
        localStream = stream;
        if (isMounted) {
          setStreamRef(stream);
        } else {
          console.warn('Stopping stream because component unmounted before stream ready');
          stream.getTracks().forEach((track) => {
            track.stop();
          });
          setStreamRef(null);
        }
      });
    }
    return () => {
      isMounted = false;
      localStream?.getTracks().forEach((track) => {
        track.stop();
      });
      setStreamRef(null);
    };
  }, [enabled, device]);

  return streamRef;
}
